import theme from '~lib/styles/Theme';
import type { IconProps } from '~types/icon';

const ExclamationFilledMark = ({ width = 16, color, ...props }: IconProps) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M8.99984 0.666687C4.39984 0.666687 0.666504 4.40002 0.666504 9.00002C0.666504 13.6 4.39984 17.3334 8.99984 17.3334C13.5998 17.3334 17.3332 13.6 17.3332 9.00002C17.3332 4.40002 13.5998 0.666687 8.99984 0.666687ZM9.83317 13.1667H8.1665V11.5H9.83317V13.1667ZM9.83317 9.83335H8.1665V4.83335H9.83317V9.83335Z'
        fill={color || theme.colors.gray200}
      />
    </svg>
  );
};

export default ExclamationFilledMark;
